const { userAgentData: uaDATA } = navigator;

/**
 * A global namespace for `userAgentData` object.
 */
const userAgentData = uaDATA;
export default userAgentData;
